// Режим главного меню клиентского портала (только desktop >= 960px):
//   topbar     - горизонтальное меню в шапке (как было всегда, дефолт)
//   side       - широкая боковая колонка: иконка + подпись
//   side-icons - узкая боковая колонка: только иконки, подпись в tooltip
// Хранится в localStorage per-device (как тема). На мобильном (< 960px) не
// применяется - там всегда бургер + выезжающая шторка.
// Раскладку делает App.vue: класс .app-shell--side-nav по sideNavActive (режим +
// desktop по matchMedia + страница с навигацией). Атрибут data-nav на <html> -
// только маркер состояния для отладки, CSS от него не зависит.

const STORAGE_KEY = 'navLayout'
const DEFAULT_LAYOUT = 'topbar'
export const NAV_LAYOUTS = ['topbar', 'side', 'side-icons']

const listeners = new Set()

function getStoredLayout() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    return NAV_LAYOUTS.includes(raw) ? raw : DEFAULT_LAYOUT
  } catch {
    return DEFAULT_LAYOUT
  }
}

// Текущий выбор пользователя (topbar|side|side-icons).
export function getNavLayout() {
  return getStoredLayout()
}

// Применяет режим к документу. Без сохранения - это делает setNavLayout.
export function applyNavLayout(layout = getStoredLayout()) {
  if (typeof document !== 'undefined') {
    const prev = document.documentElement.getAttribute('data-nav') || DEFAULT_LAYOUT
    if (layout === DEFAULT_LAYOUT) {
      document.documentElement.removeAttribute('data-nav')
    } else {
      document.documentElement.setAttribute('data-nav', layout)
    }
    // Макет перестроился (колонка меню появилась/сменила ширину): Leaflet слушает
    // window.resize (trackResize по умолчанию) и сам делает invalidateSize, иначе
    // карта остаётся с прежней шириной и маркеры уезжают. Кадр спустя, чтобы
    // браузер успел применить новые размеры.
    if (prev !== layout && typeof window !== 'undefined') {
      requestAnimationFrame(() => window.dispatchEvent(new Event('resize')))
    }
  }
  notify(layout)
}

// Меняет режим: сохраняет в localStorage и применяет.
export function setNavLayout(layout) {
  if (!NAV_LAYOUTS.includes(layout)) {
    throw new Error(`Invalid nav layout: ${layout}`)
  }
  localStorage.setItem(STORAGE_KEY, layout)
  applyNavLayout(layout)
}

// Подписка на смену режима - для компонентов, которым нужно пересчитать
// размеры после перестройки макета (карта Leaflet: invalidateSize).
export function subscribe(callback) {
  listeners.add(callback)
  return () => listeners.delete(callback)
}

function notify(layout) {
  listeners.forEach((cb) => {
    try {
      cb(layout)
    } catch (e) {
      console.error('[navLayoutService] listener error:', e)
    }
  })
}

// Инициализация - один раз на старте приложения.
export function initNavLayout() {
  applyNavLayout()
}
